import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Phone = function Phone(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Phone_svg__Phone_svg__clip0_17458_91685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.408 11.563C6.917 14.069 9.95 16 12.425 16c1.1 0 2.075-.391 2.858-1.249.45-.508.717-1.082.717-1.656 0-.475-.175-.924-.625-1.24l-2.567-1.824c-.408-.291-.75-.424-1.058-.424-.4 0-.75.224-1.142.616l-.616.607a.445.445 0 01-.325.125.783.783 0 01-.35-.1c-.525-.291-1.442-1.074-2.284-1.906-.833-.84-1.625-1.748-1.908-2.281a.78.78 0 01-.1-.35c0-.108.033-.224.125-.316l.608-.624c.392-.392.617-.741.617-1.14 0-.309-.133-.65-.425-1.058L4.133.633C3.817.19 3.35 0 2.858 0c-.566 0-1.141.241-1.641.716C.375 1.506 0 2.489 0 3.588c0 2.472 1.908 5.478 4.408 7.975z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Phone_svg__Phone_svg__clip0_17458_91685"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  }))));
};
export default Phone;